import { FamilyMember } from '../api/families';

/** Nume afișat (un singur câmp). */
export function memberDisplayName(m: Pick<FamilyMember, 'name'>): string {
  const n = (m.name || '').trim();
  return n || 'Membru';
}

/** Inițiale pentru avatar din nume. */
export function memberDisplayInitials(m: Pick<FamilyMember, 'name'>): string {
  const n = (m.name || '').trim();
  if (!n) return '?';
  const parts = n.split(/\s+/).filter(Boolean);
  if (parts.length >= 2) {
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  }
  return n.length >= 2 ? n.slice(0, 2).toUpperCase() : n[0].toUpperCase();
}
